import { combineReducers } from 'redux';
import cartReducer from 'app/reducers/cartReducer';
import facetsReducer from 'app/reducers/facetsReducer';
import galleryReducer from 'app/reducers/galleryReducer';
import pageReducer from 'app/reducers/pageReducer';
import searchPreferencesReducer from 'app/reducers/searchPreferencesReducer';

export default combineReducers({
  cart: cartReducer,
  facets: facetsReducer,
  gallery: galleryReducer,
  page: pageReducer,
  searchPreferences: searchPreferencesReducer,
});
